import { DefaultService } from '@/services/DefaultService';

/* @71139 */
export default class FaseFenologicaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(agro_fasefenologica, contexto = "agro") {
        return this._http.post(`${this._env}/${contexto}/${contexto}_fasefenologica`, agro_fasefenologica, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id, contexto = "agro") {
        return this._http.get(`${this._env}/${contexto}/${contexto}_fasefenologica/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(column = 'descricao', order = 'asc', page = 0, limit = 50, situacao = 2, contexto = "agro", ...params) {
        return this._http.get(encodeURI(`${this._env}/${contexto}/${contexto}_fasefenologica.json?page=${page}&limit=${limit}&situacao=${situacao}&column=${column}&order=${order}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(agro_fasefenologica, contexto = "agro") {
        return this._http.post(`${this._env}/${contexto}/${contexto}_fasefenologica/updatesituacao`, agro_fasefenologica, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}